export default "__VITE_ASSET__jO9vpbLd__"